import { ChangePassword, myProfileFragment, UploadAvatar } from './core';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Colors, FindLoad, Images, PermissionList, RolePermission, User } from 'utils';
import React from 'react';
import { useDispatch } from 'react-redux';
import { authActions } from 'store';
import { MinLoader, TextRow } from 'components';
import { Skeleton } from '@mui/material';

export const MyProfile = ({ info }) => {
    const classes = myProfileFragment();
    const dispatch = useDispatch();
    const loader = FindLoad('LOG_OUT');
    const loadProfile = FindLoad('GET_MY_PROFILE');
    const { userInfo } = User();

    const handleSignOut = () => {
        dispatch(authActions.logOut());
    };

    return (
        <div className={classes.wrapper}>
            <div className={classes.staffInfoWrapper}>
                {!!loadProfile?.length ? (
                    <>
                        <Skeleton variant="circular" width={56} height={56} />
                        <div>
                            <Skeleton variant="text" width={140} height={28} style={{ borderRadius: 4 }} />
                            <Skeleton variant="text" width={180} height={24} style={{ borderRadius: 4, marginTop: 2 }} />
                            <Skeleton variant="text" width={100} height={20} style={{ borderRadius: 4, marginTop: 4 }} />
                        </div>
                    </>
                ) : (
                    <>
                        <div className={classes.staffAvatar}>
                            {info?.avatar?.url ? (
                                <img src={info?.avatar?.url} alt="avatar" />
                            ) : (
                                <AccountCircleIcon style={{ fontSize: 56, color: Colors.ThemeBlue }} />
                            )}

                            <div className={classes.online} />
                        </div>
                        <div>
                            <p className={classes.staffName}>
                                <TextRow name={`${info?.firstName || ''} ${info?.lastName ? info.lastName : ''}`} />
                            </p>
                            <p className={classes.staffEmail}>{info?.email ? info?.email : '--'}</p>
                                <a className={classes.viewMyProfile} href={`/staff/${userInfo?.id}`}>
                                    View My Profile
                                </a>
                        </div>
                    </>
                )}
            </div>

            <UploadAvatar />
            <ChangePassword />

            <button onClick={handleSignOut} className={classes.signOutButton}>
                {!!loader.length ? (
                    <MinLoader margin={'0'} color={'#FE7070'} />
                ) : (
                    <>
                        <img src={Images.signOut} alt="signOut" />
                        <p>Sign Out</p>
                    </>
                )}
            </button>
        </div>
    );
};
